import React, { useEffect, useRef, useState } from "react";
import { FiChevronDown } from "react-icons/fi";

const PAGE_OPTIONS = [
  { pages: 1, properties: 100 },
  { pages: 5, properties: 500 },
  { pages: 10, properties: 1000 },
  { pages: 50, properties: 5000 },
  { pages: 100, properties: 10000 },
];

const BulkSelectionControl = ({ onSelectPages, isLoading = false, disabled = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const rootRef = useRef(null);
  const triggerRef = useRef(null);
  const isDisabled = disabled || isLoading;

  useEffect(() => {
    if (!isOpen) return undefined;

    const closeOnOutsideClick = (event) => {
      if (!rootRef.current?.contains(event.target)) setIsOpen(false);
    };

    document.addEventListener("mousedown", closeOnOutsideClick);
    return () => document.removeEventListener("mousedown", closeOnOutsideClick);
  }, [isOpen]);

  const selectPages = (pages) => {
    setIsOpen(false);
    onSelectPages(pages);
  };

  const closeOnEscape = (event) => {
    if (event.key !== "Escape") return;

    setIsOpen(false);
    triggerRef.current?.focus();
  };

  return (
    <div
      ref={rootRef}
      className="drop_filter drop_result_btn bulk_selection_control"
      onKeyDown={closeOnEscape}
    >
      <button
        ref={triggerRef}
        type="button"
        className="site_btn blank yellow_blank no_filter bulk_selection_trigger"
        disabled={isDisabled}
        aria-label={isLoading ? "Selecting properties" : "Bulk select properties"}
        aria-expanded={isOpen}
        onClick={() => setIsOpen((open) => !open)}
      >
        <span>{isLoading ? "Selecting…" : "Bulk Select"}</span>
        {!isLoading && <FiChevronDown className="bulk_selection_chevron" aria-hidden="true" />}
      </button>
      <div className={`drop_cnt bulk_selection_menu${isOpen ? " active" : ""}`}>
        <div className="option_lst" role="group" aria-label="Bulk selection size">
          {PAGE_OPTIONS.map((option) => {
            const pageLabel = option.pages === 1 ? "page" : "pages";

            return (
              <button
                key={option.pages}
                type="button"
                aria-label={`Select first ${option.pages} ${pageLabel} (${option.properties.toLocaleString()} properties)`}
                onClick={() => selectPages(option.pages)}
              >
                <span>First {option.pages} {pageLabel}</span>
                <small>{option.properties.toLocaleString()} properties</small>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BulkSelectionControl;
